// assets
import { CarOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

// icons
const icons = {
  CarOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const cars = {
  id: 'cars_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'cars',
      title: <FormattedMessage id="Cars" />,
      type: 'collapse',
      icon: icons.CarOutlined,
      children: [
        { id: 'carOperations', title: <FormattedMessage id="Car operations" />, icon: icons.CarOutlined, url: '/cars', type: 'item' },
        {
          id: 'availableCars',
          title: <FormattedMessage id="Available Cars" />,
          icon: icons.CarOutlined,
          url: '/available-cars',
          type: 'item'
        },
        {
          id: 'listVo',
          title: <FormattedMessage id="List VO" />,
          icon: icons.CarOutlined,
          url: '/list-vo',
          type: 'item'
        }
      ]
    }
  ]
};

export default cars;
